import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { throwError, of, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { OtpOption, SendOtpResponse } from 'src/app/models/otp-option';
import { OtpRequestType } from 'src/app/models/otp-option';

@Injectable({
  providedIn: 'root'
})
export class OtpService {

  constructor(private api: ApiService) { }

  private static SEND_OTP_MUTATION_NAME = {
    [OtpRequestType.CHANGE_PASSWORD]: 'sendPasswordChangeOtp',
    [OtpRequestType.CREATE_BANK]: 'sendCreateUserBankDetailsOtp'
  };

  private static OTP_OPTIONS_QUERY_NAME = {
    [OtpRequestType.CHANGE_PASSWORD]: 'passwordChangeOtpOptions',
    [OtpRequestType.CREATE_BANK]: 'userOtpOptions'
  }

  getOtpOptions(otpType: OtpRequestType): Observable<OtpOption[]> {
    const methodName = OtpService.OTP_OPTIONS_QUERY_NAME[otpType];

    return this.api.get(`query otpOptions {
        ${methodName} {
          options
        }
      }`).pipe(
      switchMap(response => {
        if (response['errors']) {
          return throwError(response);
        }

        return of(response['data']?.[methodName]?.['options']);
      }),
      this.api.unifyErrors()
    );
  }

  sendOtp(otpType: OtpRequestType, otpOption: OtpOption): Observable<SendOtpResponse> {
    const methodName = OtpService.SEND_OTP_MUTATION_NAME[otpType];

    return this.api.get(`mutation sendOtp ($otpOption: OtpOption!) {
        ${methodName} (otpOption: $otpOption) {
          ... on SendOtpResponse {
            success
            maskedPhoneNumber
            option
          }
          ... on OperationError {
            errors{
              message
              field
            }
          }
        }
      }`, {
        otpOption
      }).pipe(
      switchMap(response => {
        const data = response['data']?.[methodName];

        if (data['errors']) {
          return throwError(data);
        }

        return of(data);
      }),
      this.api.unifyErrors()
    );
  }
}
